let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7WaUI"), load("gIOIL")]).then(() => parcelRequire('gLUng'));